import React from "react";
//Icons
 import { Table, Th, Thead, Tr, Td} from 'reactable';
import {appHelpers} from "../../_helpers";
// import ProformaReportDownload from "./report-download";

class ProformaReportTable extends React.Component {
    render() {
         const nairaCurrency =  String.fromCharCode(appHelpers.getCurrencyUnicode(566));
        const dollarCurrency =  String.fromCharCode(appHelpers.getCurrencyUnicode(840));

        let { data } = this.props;
        return (
            <div>
                <Table className="table table-striped table-hover" id="table" sortable={true} itemsPerPage={15} pageButtonLimit={10} >
                    <Thead>
                    <Th column="Airline">
                        <span>Airline</span>
                    </Th>
                    <Th column="Coupons">
                        <span>Coupons</span>
                    </Th>
                    <Th column="Flights">
                        <span>Flights</span>
                    </Th>
                    <Th column="LocalTickets">
                        <span>Local Tickets</span>
                    </Th>
                    <Th column="ForeignTickets">
                        <span>Foreign Tickets</span>
                    </Th>
                    <Th column="FreeTickets">
                        <span>Free Tickets</span>
                    </Th>
                    <Th column="EndorsedTickets">
                        <span>Endorsed Tickets</span>
                    </Th>
                    <Th column="Passengers">
                        <span>Passengers</span>
                    </Th>
                    <Th column="TaxablePax">
                        <span>Taxable Pax</span>
                    </Th>
                    <Th column="ExemptedPax">
                        <span>Exempted Pax</span>
                    </Th>
                    <Th column="SalesLevyNGN">
                        <span>{ `Sales Levy (${nairaCurrency})` }</span>
                    </Th>
                    <Th column="SalesLevyUSD">
                        <span>{ `Sales Levy (${dollarCurrency})` }</span>
                    </Th>
                    <Th column="ConvertedSalesLevy">
                        <span>Converted Sales Levy</span>
                    </Th>
                    <Th column="TotalSalesLevy">
                        <span>{`Total (${nairaCurrency})` }</span>
                    </Th>
                    <Th column="RevMktShare">
                        <span>Rev. MKT Share (%)</span>
                    </Th>
                    <Th column="PaxMktShare">
                        <span>Pax. MKT Share (%)</span>
                    </Th>
                    </Thead>

                    {data.map((item, i) => <Tr key={i}>
                        <Td column="Airline" className="text-capitalize">{item.Airline}</Td>
                        <Td column="Coupons">{item.Coupons}</Td>
                        <Td column="Flights">{item.Flights}</Td>
                        <Td column="LocalTickets">{item.LocalTickets}</Td>
                        <Td column="ForeignTickets">{item.ForeignTickets}</Td>
                        <Td column="FreeTickets">{item.FreeTickets}</Td>
                        <Td column="EndorsedTickets">{item.EndorsedTickets}</Td>
                        <Td column="Passengers">{item.Passengers}</Td>
                        <Td column="TaxablePax">{item.TaxablePax}</Td>
                        <Td column="ExemptedPax">{item.ExemptedPax}</Td>
                        <Td column="SalesLevyNGN">{ appHelpers.numberWithCommas(item.SalesLevyNGN) }</Td>
                        <Td column="SalesLevyUSD">{ appHelpers.numberWithCommas(item.SalesLevyUSD) }</Td>
                        <Td column="ConvertedSalesLevy">{ appHelpers.numberWithCommas(item.ConvertedSalesLevy) }</Td>
                        <Td column="TotalSalesLevy">{ appHelpers.numberWithCommas(item.TotalSalesLevy) }</Td>
                        <Td column="RevMktShare">{ item.RevMktShare }</Td>
                        <Td column="PaxMktShare">{ item.PaxMktShare }</Td>
                    </Tr>)}
                </Table>

                {/*
                    This is a cool display of the download but we have to do away with it for now
                <div>
                    <ProformaReportDownload positionFromBottom={`${positionFromBottom}px`} handleReportDownload={ handleReportDownload }/>
                </div>
                */}
            </div>
        )
    }
}
export default ProformaReportTable;



// WEBPACK FOOTER //
// ./src/views/proforma/report-table.js